const GLASS_MATERIAL_VALUE = '0'

const DYE_FIELDS = [
  'dye_color',
  'dye_not_listed',
  'dye_type',
  'dye_details',
  'lens_lighten_darken',
]

const GLASS_COATING_FIELDS = [
  'glass_coating',
  'glass_coating_description',
]

const hasSelection = (value) => value !== undefined && value !== null && value !== ''

const isRightEyeField = (fieldLabel) => fieldLabel?.startsWith('right_')

const isLeftEyeField = (fieldLabel) => fieldLabel?.startsWith('left_')

const isLensFieldDisabled = (fieldLabel, lens = {}) => {
  const { material, one_lens: oneLens, balance_lens: balanceLens, ar_coating: arCoating, scratch_coating: scratchCoating } = lens

  if (fieldLabel === 'balance_lens' && hasSelection(oneLens)) return true
  if (fieldLabel === 'one_lens' && hasSelection(balanceLens)) return true

  if (material === GLASS_MATERIAL_VALUE && DYE_FIELDS.includes(fieldLabel)) return true

  if (fieldLabel === 'scratch_coating' && hasSelection(arCoating)) return true
  if (fieldLabel === 'ar_coating' && hasSelection(scratchCoating)) return true

  if (GLASS_COATING_FIELDS.includes(fieldLabel) && material !== GLASS_MATERIAL_VALUE) return true

  return false
}

const isPrescriptionFieldDisabled = (fieldLabel, lens = {}) => {
  const { one_lens: oneLens, balance_lens: balanceLens } = lens

  if (oneLens === 'RIGHT' && isLeftEyeField(fieldLabel)) return true
  if (oneLens === 'LEFT' && isRightEyeField(fieldLabel)) return true

  if (balanceLens === 'RIGHT' && isRightEyeField(fieldLabel)) return true
  if (balanceLens === 'LEFT' && isLeftEyeField(fieldLabel)) return true

  return false
}

export const shouldDisableEyefinityField = ({ fieldLabel, sectionName, formValues }) => {
  if (!fieldLabel) return false

  if (fieldLabel !== 'date_of_service' && !formValues?.basic_info?.date_of_service) return true

  const lens = formValues?.lens || {}

  if (sectionName === 'lens') {
    return isLensFieldDisabled(fieldLabel, lens)
  }

  if (sectionName === 'prescription') {
    return isPrescriptionFieldDisabled(fieldLabel, lens)
  }

  return false
}
